import script from "./TheNav.vue?vue&type=script&setup=true&lang=js"
export * from "./TheNav.vue?vue&type=script&setup=true&lang=js"

import "./TheNav.vue?vue&type=style&index=0&id=4012d09e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4012d09e"]])

export default __exports__